import React, { useMemo, useState } from 'react'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
} from '@mui/material'
import { Controller, useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import { useSnackbar } from 'notistack'
import ErrorMessage from '../../errors/ErrorMessage'
import { dateRequired } from '../yup-helper'
import { useSyncMapTrans } from '../../../hooks/api/map-transactions'
import { extractErrorMessage } from '../../../utils/extractErrorMessage'

const schema = yup.object({
  syncDate: dateRequired('Sync Date'),
})

const NoTransaction = ({ mapId, refetch }) => {
  const [open, setOpen] = useState(false)
  const { enqueueSnackbar } = useSnackbar()
  const { mutateAsync, isLoading } = useSyncMapTrans()

  const defaultValues = useMemo(() => ({ syncDate: '' }), [])
  const { control, handleSubmit, reset } = useForm({
    resolver: yupResolver(schema),
    defaultValues,
  })

  const onClose = () => {
    setOpen(false)
    reset(defaultValues)
  }

  const onSubmit = async ({ syncDate }) => {
    try {
      await mutateAsync({ syncDate, mapId })
      enqueueSnackbar('Transactions synced successfully.', { variant: 'success' })
      onClose()
      refetch()
    } catch (e) {
      enqueueSnackbar(extractErrorMessage(e), { variant: 'error' })
    }
  }

  return (
    <>
      <Stack alignItems='center' spacing={2}>
        <ErrorMessage empty message='No transactions found.' />
        <Button variant='contained' onClick={() => setOpen(true)}>
          Sync
        </Button>
      </Stack>
      <Dialog maxWidth='sm' fullWidth open={open}>
        <DialogTitle>Sync Transactions</DialogTitle>
        <DialogContent dividers>
          <Controller
            name='syncDate'
            control={control}
            render={({ field, fieldState: { error } }) => (
              <TextField
                {...field}
                label='Sync Date'
                variant='outlined'
                fullWidth
                type='date'
                InputLabelProps={{ shrink: true }}
                error={!!error}
                helperText={error?.message}
              />
            )}
          />
        </DialogContent>
        <DialogActions>
          <Button variant='outlined' onClick={onClose} disabled={isLoading}>
            Cancel
          </Button>
          <Button variant='contained' onClick={handleSubmit(onSubmit)} disabled={isLoading}>
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default NoTransaction
